import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-eec-image-modal',
  templateUrl: './eec-image-modal.component.html',
  styleUrls: ['./eec-image-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class EecImageModalComponent {

  constructor(
    private dialogRef: MatDialogRef<EecImageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      src: string,
      title?: string
    }) {}

  closeDialog() {
    this.dialogRef.close();
  }
}

